import axios from "axios";

export const ClinetbaseURL = "https://admin.simplifyte.com/api";


// 2️⃣ CREATE AXIOS INSTANCE
const freePlanClient = axios.create({
  baseURL: ClinetbaseURL,
  headers: {
    Accept: "application/json",
  },
});

// freePlanClient.interceptors.request.use((config) => {
//   console.log("ATTACHING TOKEN:", config.headers.Authorization);
//   return config;
// });

// 3️⃣ ADD TOKEN TO EVERY REQUEST AUTOMATICALLY
// freePlanClient.interceptors.request.use(
//   (config) => {
//     const token = "30|Hyv16CzzBiSyQrupdOwbi52M2kSftc49NDhmOLfg4800bfe1";
//     // const token = localStorage.getItem("token");
//     // console.log(token);
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error),
// );

export default freePlanClient;
